import React, { useContext, useEffect, useState } from 'react'
import { Select, Input } from 'antd'
import { getSrpSystemCodeCodeInfo } from 'api/pgads'
import { ErrorContext } from 'context'
const { Option } = Select
const SrpExtension = props => {
  const {
    data,
    allData,
    handleExtSave,
    disableComp = false,
    targetInfo,
    units,
  } = props

  const { setError } = useContext(ErrorContext)

  const { string5, string6 } = data
  const { unit } = allData

  const [systemCode, setSystemCode] = useState([])

  useEffect(
    _ => {
      getSrpSystemCodeCodeInfo(targetInfo).fork(setError, data => {
        const id1 = (units.find(u => u.unitId === unit) || {}).id1
        const unitTypeSrp = data.filter(f => f.unitcode === id1)
        setSystemCode(unitTypeSrp)
      })
    },
    [setError, targetInfo, unit, units]
  )

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '150px 1fr',
        gridGap: '30px',
      }}
    >
      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
        SRP System Code :
      </div>
      <Select
        value={string5}
        onChange={value => handleExtSave('string5', value)}
        key="string5"
        disabled={disableComp}
      >
        <Option key="-1" value="" style={{ height: '20px' }} />
        {systemCode.map(({ srpSystemcode, description }) => (
          <Option key={srpSystemcode} value={srpSystemcode}>
            {description || srpSystemcode}
          </Option>
        ))}
      </Select>

      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
        SRP MAXIMO ID :
      </div>
      <Input
        disabled={disableComp}
        value={string6}
        onChange={e => handleExtSave('string6', e.target.value)}
      />
    </div>
  )
}

export default SrpExtension
